<template>
  <div class="createPlayStep">
    <div class="backBox">
      <img
        class="pointer"
        @click="clickLocalStep()"
        src="@/assets/thdImg/pages/back.svg"
        alt=""
      />
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div class="formBox">
      <!-- 步骤条 -->
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="1">
          <el-step title="活动模板"></el-step>
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>
      <!--  活动条件表单部分 -->
      <div class="secondstep">
        <el-form
          :model="ruleForm"
          :rules="rules"
          class="backgroundForm"
          ref="ruleForm"
          label-width="120px"
        >
          <el-form-item label="活动名称:" required>
            <el-input
              v-model="ruleForm.activityName"
              maxlength="50"
              show-word-limit
              placeholder="积分任务的展示名称"
              style="width: 400px"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动时间:" required>
            <div class="my_select_time">
              <el-date-picker
                v-model="activityTimeValue"
                type="datetimerange"
                class="rangeTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                ref="timeBox"
                @change="activityTimeChange"
                style="width: 400px; font-size: 12px"
                :picker-options="pickerOptionsValue"
                :default-time="defaultTime"
              >
              </el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                @click="activityTimeValue = []"
              ></i>
              <img
                src="@/assets/images/select_date.svg"
                alt=""
                class="date_icon2"
              />
            </div>
            <span class="lastTime" style="color: #666">
              活动持续 <span style="color: #2670fb">{{ timeDay }}</span> 天
              <span style="color: #2670fb">{{ timeOut }}</span> 小时
              <el-tooltip
                class="item"
                effect="light"
                content="活动有效期不可超过订购有效期"
                placement="bottom"
              >
                <el-button type="text" style="width: 35px">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </span>
          </el-form-item>
          <el-form-item label="活动对象:" required>
            <el-radio-group
              v-model="ruleForm.activityObject"
              :disabled="isStartEdit"
              @change="handleActivityObj"
              style="margin-right: 16px"
            >
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="1">指定身份</el-radio>
              <el-radio :label="2" disabled>指定人群</el-radio>
            </el-radio-group>
            <el-popover
              placement="right-start"
              trigger="hover"
              content="您不满足使用该功能的条件，请联系专属客服了解~"
            >
              <el-button slot="reference" disabled>{{
                peopleList.length == 0
                  ? "选择人群"
                  : `已选${peopleList.length}个`
              }}</el-button>
            </el-popover>
          </el-form-item>
          <el-form-item
            label="新老客户:"
            required
            v-if="ruleForm.activityObject == '1'"
          >
            <el-radio-group
              v-model="ruleForm.newOldCustomer"
              :disabled="isStartEdit"
            >
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="1">新客</el-radio>
              <el-radio :label="2">老客</el-radio>
            </el-radio-group>
            <el-tooltip effect="dark" placement="top-start">
              <div slot="content">
                1、历史订单中已完成订单的订单数为0则定义为新客<br />2、历史订单中已完成订单的订单数≥1则定义为新客
              </div>
              <div
                class="cursorPointer"
                style="
                  display: inline-block;
                  margin-left: 16px;
                  font-size: 12px;
                  color: #999;
                "
              >
                <span>新老客说明</span>
                <i class="el-icon-question"></i>
              </div>
            </el-tooltip>
          </el-form-item>
          <el-form-item
            label="参与对象:"
            prop="partner"
            v-if="ruleForm.activityObject == '1'"
          >
            <el-checkbox-group
              v-model="ruleForm.partner"
              @change="checkListchange"
              :disabled="isStartEdit"
            >
              <el-checkbox label="-1" name="partner">全部</el-checkbox>
              <el-checkbox
                label="0"
                name="partner"
                :disabled="ruleForm.partner == -1"
                >非会员</el-checkbox
              >

              <el-checkbox
                v-for="(item, index) in levelList"
                :key="index"
                :label="index + 1 + ''"
                name="partner"
                :disabled="ruleForm.partner == -1"
                >{{ item }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <el-form-item
            label="入会时间:"
            v-if="ruleForm.activityObject == '1' && ruleForm.partner != 0"
          >
          <el-date-picker
            v-model="ruleForm.membershipTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            type="datetime"
            :disabled="
                nowType == 'look' ||
                (nowType == 'edit' && activityData.status == 2)
              "
            placeholder="选择日期时间">
          </el-date-picker>
          之后成为会员的用户可参与活动
          </el-form-item>
          <el-form-item label="背景设置:" prop="partner">
            <el-radio v-model="picType1" :label="0" :disabled="isStartEdit"
              >系统预设</el-radio
            >
            <el-radio v-model="picType1" :label="1" :disabled="isStartEdit"
              >自定义</el-radio
            >
            <div class="m-b-24" v-show="picType1 == 0">
              <img
                src="https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/yunqihd_C/default-free.png"
                class="avatar"
              />
            </div>
            <div v-show="picType1 == 1">
              <div class="imgUpload m-b-20">
                <el-upload
                  class="avatar-uploader"
                  action=""
                  multiple
                  :limit="1"
                  :before-upload="beforeUpload1"
                  accept=".jpg,.png"
                  :disabled="isStartEdit"
                >
                  <img v-if="imageUrl1" :src="imageUrl1" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <div style="color: #999999; margin-bottom: 10px">
                  <p class="my-mg-10">建议上传尺寸：750px*1820px</p>
                  <p class="my-mg-10">图片大小：2MB以内</p>
                  <p class="my-mg-10">格式：jpg、png</p>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="试用商品:" prop="setPrize">
            <el-button @click="addTask" :disabled="isStartEdit"
              >+添加商品</el-button
            >
          </el-form-item>
          <!-- 试用商品显示 -->
          <el-form-item label="" prop="setPrize">
            <div class="wide" v-for="(item, index) in trialList" :key="index">
              <div class="rulebox_flex">
                <div>奖品名称：{{ item.freeTryOutItemInfoDTOList.title }}</div>
                <div class="posi">
                  <el-button
                    :disabled="isStartEdit"
                    style="width: 50px"
                    @click="moveUP(trialList[index], index)"
                    >上移</el-button
                  >
                  <el-button
                    :disabled="isStartEdit"
                    style="width: 50px"
                    @click="moveDown(trialList[index], index)"
                    >下移</el-button
                  >
                  <el-button style="width: 50px" @click="edit(item, index)"
                    >编辑</el-button
                  >
                  <el-button
                    :disabled="isStartEdit"
                    style="width: 50px"
                    @click="deletePacket(index)"
                    >删除</el-button
                  >
                </div>
              </div>
              <div class="rulebox_flex">
                <div>
                  奖品图片：
                  <img
                    style="
                      width: 80px;
                      height: 80px;
                      vertical-align: top;
                      border-radius: 4px 4px 4px 4px;
                    "
                    :src="item.freeTryOutItemInfoDTOList.logo"
                    alt=""
                    class="date_icon3"
                  />
                </div>
              </div>
              <div class="rulebox_flex">
                <div>奖品价值：{{ item.freeTryOutItemInfoDTOList.price }}</div>
              </div>
              <div class="rulebox_flex">
                <div>
                  参与要求：{{
                    item.freeTryOutItemInfoDTOList.freeJoinType == 0
                      ? "不限制"
                      : item.freeTryOutItemInfoDTOList.freeJoinType == 1
                      ? "限会员"
                      : item.freeTryOutItemInfoDTOList.freeJoinType == 2
                      ? "限粉丝"
                      : "限粉丝,限会员"
                  }}
                </div>
              </div>
              <div class="rulebox_flex">
                <div>
                  试用方式：{{
                    item.freeTryOutItemInfoDTOList.freeTryOutType == 0
                      ? "0元试用"
                      : "积分试用"
                  }}<span
                    v-if="item.freeTryOutItemInfoDTOList.freeTryOutType == 1"
                    >,消耗{{
                      item.freeTryOutItemInfoDTOList.freeTryOutPointNum
                    }}积分获得试用报名机会</span
                  >
                </div>
              </div>
              <div class="rulebox_flex">
                <div>
                  开奖方式：{{
                    item.freeTryOutItemInfoDTOList.freeLotteryOpenType == 0
                      ? "手动审核开奖"
                      : item.freeTryOutItemInfoDTOList.freeLotteryOpenType == 1
                      ? "开奖时间随机开奖"
                      : item.freeTryOutItemInfoDTOList.freeLotteryOpenType == 2
                      ? "申请后立即开奖"
                      : ""
                  }}
                  <span
                    v-if="
                      item.freeTryOutItemInfoDTOList.freeLotteryOpenType == 2
                    "
                    >,中奖概率为{{
                      item.freeTryOutItemInfoDTOList.percentage
                    }}%</span
                  >
                </div>
              </div>
              <div
                class="rulebox_flex"
                v-if="item.freeTryOutItemInfoDTOList.prizeType != 10"
              >
                <div
                  v-if="
                    item.freeTryOutItemInfoDTOList.freeWriteAddressType == 1
                  "
                >
                  收货地址填写：中奖
                  {{ item.freeTryOutItemInfoDTOList.freeWriteAddressDay }}
                  天内填写
                </div>
                <div v-else>收货地址填写：填写地址后申请</div>
              </div>
              <div class="rulebox_flex">
                <div>
                  奖品份数：{{ item.freeTryOutItemInfoDTOList.totalAmount }} 份
                </div>
              </div>
              <div class="rulebox_flex">
                <div>
                  开奖时间：{{ item.freeTryOutItemInfoDTOList.freeEndTime }}
                </div>
              </div>
            </div>
          </el-form-item>
          <!-- 中奖名单显示 -->
          <el-form-item label="中奖名单显示:" prop="exposure">
            <el-radio-group
              v-model="isDisplayWinningList"
              :disabled="isStartEdit"
            >
              <el-radio :label="0">不显示</el-radio>
              <el-radio :label="1">显示（C端小程序开启显示中奖名单）</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 曝光商品 -->
          <el-form-item label="曝光商品:" prop="exposure" class="zindexBox">
            <el-checkbox v-model="ruleForm.exposureSwitch">
              是否添加曝光商品
            </el-checkbox>
            <el-button
              style="width: 155px; margin: 0 15px"
              @click="exposureProducts"
              :disabled="ruleForm.exposureSwitch == false"
            >
              {{
                itemListFor.length != ""
                  ? "添加曝光商品" + "(" + itemListFor.length + "/20" + ")"
                  : "添加曝光商品"
              }}
            </el-button>
            <draggable
              v-if="itemListFor.length > 0"
              v-model="mainImagelist"
              chosen-class="chosen"
              :scroll="true"
              animation="150"
              force-fallback="true"
              @start="isDragging = true"
              @end="onEnd"
              style="
                margin-top: 10px;
                background: rgba(38, 112, 251, 0.06);
                padding: 10px 10px 0px 10px;
              "
            >
              <transition-group type="transition">
                <div
                  v-for="(item, index) in mainImagelist"
                  :key="item.skuId"
                  style="display: inline-block; position: relative"
                  class="show_upImg2"
                >
                  <img
                    :src="item.logo"
                    width="120px"
                    height="120px"
                    style="display: inline-block"
                  />&nbsp;
                  <div class="delectPosible">
                    <span class="delectSort">拖动排序</span>
                    <img
                      src="@/assets/thdImg/pages/delet.svg"
                      @click.stop="delec(item, index)"
                      class="delectIcom"
                    />
                  </div>
                </div>
              </transition-group>
            </draggable>
          </el-form-item>
          <el-form-item label="活动规则:" required>
            <div
              style="
                width: 500px;
                backgroundcolor: rgba(250, 250, 250, 1);
                padding: 8px;
                position: relative;
              "
            >
              <el-input
                type="textarea"
                class="textarea"
                style="width: 484px"
                resize="none"
                v-model="ruleForm.activityRulesText"
                :maxlength="2000"
                :disabled="backgroundOpacity"
              ></el-input>
              <div class="prosi" style="color: #909399">
                （{{
                  ruleForm.activityRulesText.length
                    ? ruleForm.activityRulesText.length
                    : 0
                }}/2000）
              </div>
              <div>
                <el-button
                  type="primary"
                  class="generate"
                  plain
                  @click="generateRule"
                  :disabled="backgroundOpacity"
                >
                  生成规则
                </el-button>
                <span class="desc">
                  <i
                    class="el-alert__icon el-icon-info"
                    style="color: #999"
                  ></i>
                  点击按钮自动生成规则，也可以自己编辑信息
                </span>
              </div>
            </div>
          </el-form-item>
          <div v-if="backgroundOpacity" class="backgroundOpacity"></div>
        </el-form>
      </div>
    </div>
    <div class="create_bottom">
      <el-button
        v-show="!itemId"
        class="createBtn create_bottom_returnBtn"
        size="medium"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</el-button
      >
      <template v-if="!backgroundOpacity">
        <el-button
          v-show="!itemId"
          v-if="isSave"
          class="createBtn create_bottom_keepBtn"
          type="primary"
          size="medium"
          @click="saveEdit"
          v-preventReClick
          >保存设置</el-button
        >
      </template>
      <el-button
        v-show="itemId"
        class="createBtn create_bottom_returnBtn"
        size="medium"
        @click="cancelEdit"
        >取消</el-button
      >
      <el-button
        v-show="itemId"
        class="createBtn create_bottom_keepBtn"
        type="primary"
        size="medium"
        >保存设置</el-button
      >
    </div>
    <selectGoodsMonitor
      v-if="selectGoodsState"
      @transferName="selectGoodsClose"
      :postForm="selectGoodsArr"
      :maxNum="20"
    >
    </selectGoodsMonitor>
    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <el-button @click="joinBlackList = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 添加任务 -->
    <el-dialog
      :title="nameTitle"
      :visible.sync="dialogFormVisible"
      width="570px"
    >
      <div
        class="rulebox"
        style="
          background: #fff;
          margin-top: 0;
          padding: 0;
          width: 500px;
          min-height: 254px;
          margin-left: 12px;
        "
      >
        <div class="rulebox_flex">
          <span class="rulebox_flex_left">奖品来源：</span>
          <div>
            <el-button
              @click="centerVis"
              style="margin-left: -30px"
              :disabled="isStartEdit"
              >选择奖品</el-button
            >
          </div>
        </div>
        <!-- Note奖品显示 -->
        <div class="rulebox_flex">
          <!-- 选择奖品显示 -->
          <div class="theLag" v-if="prizeSettingList.prizeType">
            <div class="theBox">
              <div
                v-if="
                  prizeSettingList.prizeType != 3 &&
                  prizeSettingList.prizeType != 10
                "
                class="flex"
                style="
                  margin: 30px 0 15px 0;
                  width: 280px;
                  justify-content: center;
                "
              >
                <div class="price_sty">{{ prizeSettingList.prizeTxt }}</div>
                <div
                  style="
                    height: 44px;
                    width: 1px;
                    background: #fe4d45;
                    opacity: 0.2;
                    margin: 0 12px;
                  "
                ></div>
                <div style="color: #999999">
                  {{ prizeSettingList.prizeType | prizeType }}
                </div>
              </div>
              <p
                v-else
                style="
                  margin: 30px 0 25px 0;
                  width: 280px;
                  text-align: center;
                  padding-left: 25px;
                  text-overflow: -o-ellipsis-lastline;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 1;
                  line-clamp: 1;
                  -webkit-box-orient: vertical;
                "
              >
                {{ prizeSettingList.title }}
              </p>
              <p class="pp">{{ prizeSettingList.prizeType | prizeType }}</p>
            </div>
            <div class="backgrd"></div>
            <el-button
              class="btnQx"
              type="primary"
              @click="deleteCoupon"
              :disabled="isStartEdit"
              >删除</el-button
            >
          </div>
        </div>
        <div class="rulebox_flex">
          <span class="rulebox_flex_left">参与要求：</span>
          <el-checkbox-group
            :disabled="isStartEdit"
            v-model="ruleForm.information"
            @change="handleDischange"
            style="margin-left: -30px"
          >
            <el-checkbox label="-1" name="partner" :disabled="disItem == 1"
              >不限制</el-checkbox
            >
            <el-checkbox
              label="限粉丝"
              name="partner"
              :disabled="disItem == 2"
            ></el-checkbox>
            <el-checkbox
              label="限会员"
              name="partner"
              :disabled="disItem == 2"
            ></el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="rulebox_flex">
          <span class="rulebox_flex_left">试用方式：</span>
          <el-radio
            v-model="trialProducts.trialMode"
            :label="0"
            style="margin-left: -30px"
            :disabled="isStartEdit"
            >0元试用</el-radio
          >
          <el-radio
            v-model="trialProducts.trialMode"
            :label="1"
            :disabled="isStartEdit"
            >积分试用</el-radio
          >
        </div>
        <div class="rulebox_flex" v-if="trialProducts.trialMode == 1">
          <span class="rulebox_flex_left"></span>
          消耗&nbsp;<el-input
            :disabled="isStartEdit"
            v-model="trialProducts.score"
            placeholder="请填入"
            style="width: 80px"
            @input="trialProducts.score = getNumberData($event, 0)"
          ></el-input
          >&nbsp;积分获得试用报名机会
        </div>
        <div class="rulebox_flex">
          <span class="rulebox_flex_left">开奖方式：</span>
          <el-radio
            :disabled="isStartEdit"
            v-model="trialProducts.openMethods"
            :label="0"
            @change="openThing"
            style="margin-left: -30px"
            >手动审核开奖</el-radio
          >
          <el-radio
            :disabled="isStartEdit"
            v-model="trialProducts.openMethods"
            :label="1"
            @change="openThing"
            >开奖时间随机开奖</el-radio
          >
          <el-radio
            :disabled="isStartEdit"
            v-model="trialProducts.openMethods"
            :label="2"
            @change="openThing"
            >申请后立即开奖</el-radio
          >
        </div>
        <div class="rulebox_flex" v-if="trialProducts.openMethods == 2">
          <span class="rulebox_flex_left">中奖概率：</span>
          <el-input
            :disabled="isStartEdit"
            v-model="trialProducts.probability"
            placeholder="请填入"
            style="width: 80px; margin-left: -30px"
            @input="trialProducts.probability = getNumberData($event, 1)"
          ></el-input
          >&nbsp;%
        </div>
        <div class="rulebox_flex" v-if="!isBelong">
          <span class="rulebox_flex_left">收货地址填写：</span>
          <el-radio
            :disabled="isStartEdit"
            v-if="trialProducts.openMethods != 2"
            v-model="trialProducts.shipToAddress"
            :label="0"
            >填写地址后申请</el-radio
          >&nbsp;&nbsp;&nbsp;
          <el-radio
            :disabled="isStartEdit"
            style="margin-left: -12px"
            v-model="trialProducts.shipToAddress"
            :label="1"
            >中奖后&nbsp;<el-input
              :disabled="isStartEdit"
              v-model="trialProducts.day"
              placeholder="请填入"
              style="width: 80px"
              @input="trialProducts.day = getNumberData($event, 0)"
            ></el-input
            >&nbsp;天内填写</el-radio
          >&nbsp;&nbsp;&nbsp;
        </div>
        <div class="rulebox_flex">
          <span class="rulebox_flex_left">奖品份数：</span>
          <div>
            <el-input
              @blur="beAdd()"
              v-model="trialProducts.prizes"
              placeholder="请填入"
              style="width: 80px; margin-left: -30px"
              @input="trialProducts.prizes = getNumberData($event, 0)"
            ></el-input
            >&nbsp;份
          </div>
        </div>
        <div class="rulebox_flex">
          <span class="rulebox_flex_left">开奖时间：</span>
          <div>
            <el-date-picker
              :disabled="isStartEdit"
              style="margin-left: -30px"
              v-model="trialProducts.endTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期时间"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="rulebox_flex" style="justify-content: center">
          <div class="createAdd_qx pointer" @click="dialogFormVisible = false">
            取消
          </div>
          <div class="createAdd_save pointer" @click="handleSave">确定</div>
        </div>
      </div>
    </el-dialog>
    <!-- 选择奖品弹窗 -->
    <selectProduct
      :putPrize="putPrize"
      :hide="1"
      @close="colseDialog"
      v-if="showDialog"
      :tipShow="true"
      ref="selectProduct"
      @choose-shop="getTheData"
    >
    </selectProduct>
  </div>
</template>

<script>
import {
  invite,
  editInvite,
  searchInvite,
  freeTryOutActivity,
  follow,
  editfollow,
  searchfollow,
  information,
  editInformationAa,
  searchInformation,
  creatPrize,
  editPrize,
  searchPrize,
  priceTry,
} from "@/api/integralCenter/integralTask";
import { uploadImage } from "@/api/sellerImageController";
import {
  jingdouList,
  allAccountList,
  redPacketList,
} from "@/api/integralCenter/prizeCenter.js";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
import selectProduct from "./select_product.vue";
import QRCode from "qrcodejs2";
import { mapState, mapMutations } from "vuex";
import selectGoodsMonitor from "@/components/selectGoodsMonitor";
import draggable from "vuedraggable";
const prizeName = [
  "",
  "",
  "京豆",
  "实物",
  "店铺积分",
  "淘宝E卡",
  "爱奇艺会员",
  "淘宝PLUS会员",
  "现金红包",
];
const cityOptions = [
  {
    value: 0,
    name: "限会员",
  },
  {
    value: 1,
    name: "限粉丝",
  },
];
export default {
  components: {
    selectProduct,
    selectGoodsMonitor,
    draggable,
  },
  created() {
    this.activityData = this.$route.query.activityData;
    this.localStepNum = this.activityData.id;
    console.log("this.$route.query------>", this.$route.query);
    console.log("this.localStepNum------>", this.localStepNum);
    if (this.$route.query.valueRow) {
      this.valueRow = this.$route.query.valueRow;
      this.backgroundOpacity =
        this.$route.query.backgroundOpacity == "true" ? true : false;
      this.isSave = this.$route.query.isSave == "true" ? true : false;
      this.isStartEdit = this.$route.query.isStartEdit == "true" ? true : false;
      this.priceTry();
    } else if (this.$route.query.copyParams) {
      // 复制
      this.isCopy = true;
      this.backgroundOpacity = false;
      this.isSave = true;
      this.valueRow = this.$route.query.copyParams.valueRow;
      this.isStartEdit = false;
      this.priceTry();
    } else {
      this.activityTimeChange();
    }
    this.getLevel();
  },
  filters: {
    prizeType(num) {
      var result = "";
      if (num == "1") {
        result = "优惠券";
      } else if (num == "2") {
        result = "京豆";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "5") {
        result = "淘宝E卡";
      } else if (num == "6") {
        result = "爱奇艺会员";
      } else if (num == "7") {
        result = "淘宝PLUS会员";
      } else if (num == "8") {
        result = "现金红包";
      } else if (num == "10") {
        result = "专属商品";
      }
      return result;
    },
  },
  mounted() {
    this.handleDischange();
    window.vm = this;
  },
  data() {
    return {
      peopleList: [],
      isStartEditTime: "",
      isStartEdit: false,
      isBelong: false, // 是否选择专属下单商品
      isCopy: false,
      disItem: 0,
      check3: true,
      form: {
        activityId: "",
        activityName: "",
        endTime: "",
        freeTryOutItemInfoDTOList: [],
        picType: 0,
        picUrl: "",
        ruleDescription: "",
        startTime: "",
        status: "",
      },
      eleNumber: 1,
      imgUrlOne: "",
      step: 0, //  0-入会前 1-入会后
      imageUrl1: "",
      imageUrl2: "",
      indexNum: "",
      //添加商品弹框
      nameTitle: "", //添加和编辑名称的改变
      cities: cityOptions,
      trialProducts: {
        trialMode: 0, //试用方式
        openMethods: 2, //开奖方式
        shipToAddress: 0, //收货地址填写
        checkedCities: [],
        score: "", //消耗积分
        day: "", //中奖后天数
        prizes: "", //奖品份数
        endTime: "", //开奖时间
        probability: "", //中奖概率
      },
      trialList: [],
      dialogFormVisible: false,
      element: "", //点击保存添加一行
      putPrize: {},
      prizeSettingList: {
        price: null,
        title: "",
        assetsId: null,
        prizeType: null,
        logo: "",
        price: "",
        singleAmount: "",
      },
      //End
      showDialog: false,
      JingdouCount: {
        prizeCount: 0,
      },
      typeDefault: {
        grantType: 5, // 发放类型  传对应的id值
        display: 1, // 是否公开  传对应的id值
        type: 0, // 不禁用  传对应的id值
        noDisabled: [5], // 不禁用  传对应的id值  可不传（全部可选）
      },
      dialogItem: {
        eachReachMoney: "",
        orderTime: [],
        moneyType: "",
        awardMultiple: "",
        specialAwardList: [],
      },
      picType1: 0, // 是否预设 0-系统预设 1-自定义
      isDisplayWinningList: 1, //是否显示中奖名单 0：否 1：是
      valueRow: null,
      telCode: "",
      localStep: 1,
      statusComment: false,
      localStepNum: 1,
      activityData: {
        id: 132,
      },
      activeValue: null,
      itemId: "",
      backgroundOpacity: false,
      isSave: true,
      stepNum: 1,
      //
      defaultTime: [
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
      ],
      activityTimeValue: this.$getDate(30),
      pickerOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() >
              new Date(this.$store.state.loginUserInfo.expiredIn).valueOf()
          );
        },
      },
      levelList: [],
      disableTime: false,
      clickActual: true,
      qrcode: null,
      order: "",
      testInfo: [], //动态添加完善信息
      momentValue: {}, //编辑回显
      isShow: false,

      //时间限制
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.activityStartTime) {
            return (
              time.getTime() <
              new Date(this.ruleForm.activityStartTime).getTime()
            );
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.ruleForm.activityEndTime) {
            return (
              time.getTime() > new Date(this.ruleForm.activityEndTime).getTime()
            );
          } else {
          }
        },
      },
      //每日签到
      checked: false,
      joinBlackList: false,
      draggingId: [], //有拖拽时要传的ID顺序
      saveValue: [],
      mainImagelist: [], //图片拖拽排序
      isDragging: false,
      itemListFor: [], //商品弹框选择商品数据
      selectGoodsState: false, //曝光商品弹窗
      selectGoodsArr: [],
      selectGoodsArr2: [],
      ele: "", //点击保存添加一行
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      limit: true,
      itemArr: [
        {
          continueSignPoints: "",
          days: "",
        },
      ],
      itemArrOne: [],
      activityStartTime: null,
      activityEndTime: null,

      ruleForm: {
        membershipTime:"",
        //设置规则表单
        activityName: "",
        activityObject: 0,
        newOldCustomer: 0,
        partner: ["-1"],
        isFollow: false,
        prizeSet: [],
        inputprize: "",
        exposureSwitch: false,
        radio: 0,
        startTime: "",
        prizeSite: "",
        information: ["-1"],
        activityStartTime: "", //活动开始时间
        activityEndTime: "", //活动结束时间
        singScore: null,
        activityRulesText: "", //生成规则
        bonusPoints: "", //活动名称，关注店铺有礼奖品设置积分
        peopleCount: "", //邀请开卡
        prizeSetOne: false,
        prizeCount: null,
        informationOne: [],
        isCumulativePrize: false,
      },
      tableData: [
        {
          peopleCount: "",
          prizeType: "",
          price: "",
          prizeCount: "",
          singleAmount: "",
        },
      ],
      tableIndex: null,
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 50,
            message: "长度在 3 到 50 个字符",
            trigger: "blur",
          },
        ],
        isLongTime: [
          { required: true, message: "请选择活动时间", trigger: "change" },
        ],
        activityRulesText: [
          { required: true, message: "请填写活动规则", trigger: "blur" },
        ],
        partner: [
          {
            type: "array",
            required: true,
            message: "至少选择一个",
            trigger: "change",
          },
        ],
        prizeSet: [
          {
            type: "array",
            required: true,
            message: " ",
            trigger: "change",
          },
        ],
        startTime: [{ required: true, message: "请选择开始时间" }],
        choosePrize: [{ required: true, message: "请选择奖品" }],
        prizeCount: [{ required: true, message: "请输入奖品数量" }],
        prizeSite: [{ required: true, message: " ", trigger: "blur" }],
        information: [{ required: true, message: " " }],
      },
    };
  },
  watch: {
    // localStepNum(newVal) {
    //   if (newVal == 0) {
    //     this.$nextTick(() => {
    //       this.qrcodeAll(this.activityData.telCode, queryId);
    //     });
    //   }
    // },
  },
  methods: {
    handleDischange() {
      let isdisable = false;
      this.ruleForm.information.forEach((item) => {
        if (item == "-1") isdisable = true;
      });
      if (isdisable) this.disItem = 2;
      if (!isdisable && this.ruleForm.information.length > 0) this.disItem = 1;
      if (this.ruleForm.information == 0) this.disItem = 0;
    },
    requestGetBuyerCount(e, value) {
      console.log("111111", e);
      // if(e==2){
      //   this.trialProducts.checkedCities = []
      // }
    },
    openThing(e) {
      if (e == 2) {
        this.trialProducts.shipToAddress = 1;
      } else {
        this.trialProducts.shipToAddress = 0;
      }
    },
    priceTry() {
      //回显
      priceTry(this.valueRow.id).then((res) => {
        this.activityTimeValue = [
          String(res.data.startTime),
          String(res.data.endTime),
        ];
        if (this.isStartEdit) {
          //进行中活动 无法修改活动开启时间
          this.isStartEditTime = String(res.data.startTime);
        }
        let datas, change1, change2, days, daysStart, daysEnd, date3;
        daysStart = res.data.startTime.substring(0, 10);
        daysEnd = res.data.endTime.substring(0, 10);
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        this.timeDay = days;
        //计算小时
        date3 =
          new Date(res.data.endTime).getTime() -
          new Date(res.data.startTime).getTime();
        let leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
        this.picType1 = res.data.picType;

        if (res.data.picType == 1) {
          this.imageUrl1 = String(res.data.picUrl);
        }
        this.ruleForm.activityName = res.data.activityName;

        this.isDisplayWinningList = res.data.isDisplayWinningList;
        //曝光商品
        this.ruleForm.exposureSwitch =
          res.data.isExposureItem == 0 ? false : true;
        console.log(this.ruleForm.exposureSwitch);
        // 商品处理
        let shopList = res.data.itemList
          ? res.data.itemList.map((item) => {
              return {
                ...item,
                numIid: item.wareId,
                itemTitle: item.title,
                picUrl: item.logo,
              };
            })
          : [];
        this.selectGoodsArr = shopList;
        this.itemListFor = shopList;
        this.mainImagelist = shopList;

        this.ruleForm.activityStartTime = String(res.data.startTime);
        this.ruleForm.activityEndTime = String(res.data.endTime);

        this.ruleForm.activityObject = res.data.hasOwnProperty("activityObject")
          ? res.data.activityObject
          : 0;
        this.ruleForm.newOldCustomer = res.data.hasOwnProperty("newOldCustomer")
          ? res.data.newOldCustomer
          : 0;
        this.peopleList =
          res.data.hasOwnProperty("seniorGroupId") &&
          res.data.seniorGroupId.length > 0
            ? res.data.seniorGroupId.split(",")
            : [];

        this.ruleForm.partner = res.data.allowLevel.split(",");
        this.ruleForm.membershipTime = res.data.membershipTime

        if (!this.isCopy) {
          this.ruleForm.activityRulesText = String(res.data.ruleDescription); //生成规则
          this.trialList = res.data.freeTryOutItemInfoDTOList.map((v) => ({
            ...res.data,
            prizeSettingList: {
              price: v.price,
              title: v.title,
              assetsId: v.assetsId,
              prizeType: v.prizeType,
              logo: v.logo,
              price: v.price,
              singleAmount: v.singleAmount,
              minNum: v.totalAmount,
            },
            freeTryOutItemInfoDTOList: v,
          }));
        } else {
          this.ruleForm.activityRulesText = "";
          this.trialList = [];
        }
      });
    },
    //生成规则
    generateRule() {
      this.ruleForm.activityStartTime = this.activityTimeValue[0];
      this.ruleForm.activityEndTime = this.activityTimeValue[1];
      //活动规则判断
      let text1 = "",
        text2 = "活动参与主体资格：",
        text3 =
          "  （1）每位自然人用户仅能使用一个天猫（淘宝）账号参与活动，手机号码等任意信息一致或指向同一用户，视为同一用户，则第一个参与本活动的账号参与结果有效，其他账号参与本活动均视为无效；",
        text4 =
          "  （2）若发现同一位用户使用不同账号重复参与活动，承办方有权取消其获奖资格。",
        text5 = "注意事项：",
        text6 =
          "  （1）活动过程中，凡以不正当手段（如作弊领取、恶意套取、刷信誉、虚假交易、扰乱系统、实施网络攻击等）参与本次活动的用户，商家有权终止其参与活动，并取消其获奖资格（如奖品已发放，商家有权追回），如给商家造成损失的，商家将保留向违规用户继续追索的权利。",
        text7 =
          "  （2）如遇不可抗力(包括但不限于重大灾害事件、活动受政府机关指令需要停止举办或调整的、活动中存在大面积作弊行为、活动遭受严重网络攻击或因系统故障导致活动中奖名单大批量出错，活动不能正常进行的)，商家有权取消、修改或暂停本活动。";

      //活动时间
      if (this.ruleForm.activityStartTime && this.ruleForm.activityEndTime) {
        text1 =
          "1、活动时间：" +
          this.ruleForm.activityStartTime +
          "~" +
          this.ruleForm.activityEndTime +
          ";";
      }
      //参与对象
      let text8 = "";
      if (
        this.ruleForm.activityObject == "1" &&
        this.ruleForm.partner.length > 0
      ) {
        let levelText = [];
        this.ruleForm.partner.forEach((item) => {
          if (item == -1) {
            item = "全部";
          } else if (item == 0) {
            item = "非会员";
          } else {
            this.levelList.forEach((it, index) => {
              if (index + 1 == item) {
                item = it;
              }
            });
          }
          levelText.push(item);
        });

        text8 = "2、活动参与对象：" + levelText.splice(",") + ";";
      } else {
        text8 = "2、活动参与对象：全部;";
      }
      let text34 = ""
      if (this.ruleForm.activityObject == "1" && this.ruleForm.membershipTime && this.ruleForm.partner!=[0]){
        text34 = `入会时间：${this.ruleForm.membershipTime}之后入会的会员可参与活动`
      }
      let Arr1 = [];
      Arr1 = [text1, text8,text34, text2, text3, text4, text5, text6, text7];
      let newText = "";
      Arr1.forEach((item) => {
        if (item.length > 0) {
          newText = newText + item + "\n";
        }
      });
      this.ruleForm.activityRulesText = newText;
    },
    // 上传图片
    beforeUpload1(file) {
      let _this = this;
      const isJPG = file.type === "image/jpg";
      const isJPEG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size < 2097152;
      if (!(isJPG || isPNG || isJPEG)) {
        this.$message.error("上传图片只能是JPG和PNG格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return false;
      }
      let forms = new FormData();
      forms.append("file", file);
      uploadImage(forms).then((res) => {
        this.imgUrlOne = res.data;
        if (this.step === 0) {
          this.imageUrl1 = res.data;
        } else if (this.step === 1) {
          this.imageUrl2 = res.data;
        }
        console.log(res, 1);
      });
      return !(isJPG || isPNG || isJPEG) && isLt2M;
    },
    //确定传参
    handleDialogCloseAnoth() {
      if (this.picType1 == 0) {
        this.imageUrl1 = "";
        this.imageUrl2 = "";
      }
      this.ruleForm.activityStartTime = this.activityTimeValue[0];
      this.ruleForm.activityEndTime = this.activityTimeValue[1];
      let numList = [];
      this.trialList.forEach((e, index) => {
        numList.push(e.freeTryOutItemInfoDTOList);
      });
      let params = {
        prizeSettingList: this.prizeSettingList,
        activityName: this.ruleForm.activityName,
        startTime: this.ruleForm.activityStartTime,
        endTime: this.ruleForm.activityEndTime,
        activityObject: this.ruleForm.activityObject,
        membershipTime:this.ruleForm.membershipTime,
        newOldCustomer: this.ruleForm.newOldCustomer,
        seniorGroupId: this.peopleList.join(","),
        allowLevel: this.ruleForm.partner.join(","), //参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
        picType: this.picType1,
        freeTryOutItemInfoDTOList: numList,
        picUrl: this.imageUrl1
          ? this.imageUrl1
          : this.imageUrl2
          ? this.imageUrl2
          : "",
        ruleDescription: this.ruleForm.activityRulesText,
        isDisplayWinningList: this.isDisplayWinningList,

        isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0,
        itemList: this.itemListFor.map((item) => {
          return {
            logo: item.logo,
            price: item.price,
            title: item.title,
            skuId: item.skuId,
            wareId: item.numIid,
          };
        }),
      };
      if (this.$route.query.valueRow) {
        params.activityId = this.valueRow.id;
      }
      if (this.checked == true) {
        freeTryOutActivity(params).then((res) => {
          if (res.code == 1) {
            this.$router.push({ path: "activeList" });
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //选择奖品
    centerVis(scope) {
      this.showDialog = true;
      console.log("111111", scope);
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
        this.$refs.selectProduct.physicalGift(this.prizeSettingList)
      });
    },
    //添加任务
    addTask() {
      this.nameTitle = "试用商品";
      this.prizeSettingList = {
        price: null,
        title: "",
        assetsId: null,
        prizeType: null,
        logo: "",
        price: "",
        singleAmount: "",
      };
      (this.trialProducts = {
        trialMode: 0, //试用方式
        openMethods: 0, //开奖方式
        shipToAddress: 0, //收货地址填写
        checkedCities: ["-1"],
        score: "", //消耗积分
        day: "", //中奖后天数
        prizes: "", //奖品份数
        endTime: "", //开奖时间
      }),
        (this.dialogFormVisible = true);
      this.ruleForm.information = ["-1"];
      this.disItem = 2;
    },
    colseDialog() {
      this.showDialog = false;
      this.clickActual = true;
    },
    //添加商品确定
    handleSave() {
      let cite = "";
      if (this.ruleForm.information != []) {
        cite = this.ruleForm.information.join(",");
        if (cite == "限粉丝,限会员" || cite == "限会员,限粉丝") {
          cite = 3; //限粉丝，限会员
          this.disItem = 1;
        } else if (cite == "限会员") {
          cite = 1;
          this.disItem = 1;
        } else if (cite == "限粉丝") {
          cite = 2;
          this.disItem = 1;
        } else {
          cite = 0;
          this.disItem = 2;
        }
      }
      if (this.picType1 == 0) {
        this.imageUrl1 = "";
        this.imageUrl2 = "";
      }
      if (!this.prizeSettingList.title) {
        this.$message.warning("请选择一个奖品");
        return;
      }
      if (!this.trialProducts.prizes) {
        this.$message.warning("请输入奖品份数");
        return;
      }
      if (!this.trialProducts.endTime) {
        this.$message.warning("请选择开奖时间");
        return;
      }
      if (this.trialProducts.shipToAddress == 1 && !this.trialProducts.day) {
        this.$message.warning("请输入收货地址天数填写有效天数");
        return;
      }

      this.ruleForm.activityStartTime = this.activityTimeValue[0];
      this.ruleForm.activityEndTime = this.activityTimeValue[1];

      if (this.ruleForm.activityEndTime && this.trialProducts.endTime) {
        let time1 = new Date(this.ruleForm.activityEndTime).getTime();
        let time2 = new Date(this.trialProducts.endTime).getTime();
        let timeDiff = Math.abs(time2 - time1);
        let hoursDiff = timeDiff / (1000 * 60 * 60);
        if (hoursDiff < 48 || time1 - time2 < 0) {
          // console.log('两个时间相差48小时以内');
          this.$message.warning("开奖时间要在活动结束时间之前至少48小时！");
          return;
        } else {
          // console.log('两个时间相差超过48小时');
        }
      }

      let parm = {
        activityName: this.ruleForm.activityName,
        startTime: this.ruleForm.activityStartTime,
        endTime: this.ruleForm.activityEndTime,
        picType: this.picType1,
        picUrl: this.imageUrl1
          ? this.imageUrl1
          : this.imageUrl2
          ? this.imageUrl2
          : "",
        ruleDescription: this.ruleForm.activityRulesText,
        prizeSettingList: this.prizeSettingList,
        price: this.prizeSettingList.price,
        title: this.prizeSettingList.title,
        prize: this.prizeSettingList.logo,
        trialMode: this.trialProducts.trialMode, //试用方式
        openMethods: this.trialProducts.openMethods, //开奖方式
        shipToAddress: this.trialProducts.shipToAddress, //收货地址填写
        checkedCities: this.trialProducts.checkedCities,
        score: this.trialProducts.score, //消耗积分
        day: this.trialProducts.day, //中奖后天数
        prizes: this.trialProducts.prizes, //奖品份数
        endTime: this.trialProducts.endTime, //开奖时间
        freeTryOutItemInfoDTOList: {
          prizeIndex: this.eleNumber, //序号
          assetsId: this.prizeSettingList.assetsId,
          freeEndTime: this.trialProducts.endTime,
          freeJoinType: cite,
          freeTryOutType: this.trialProducts.trialMode,
          freeLotteryOpenType: this.trialProducts.openMethods,
          totalAmount: this.trialProducts.prizes,
          freeWriteAddressType: this.trialProducts.shipToAddress,
          freeWriteAddressDay: this.trialProducts.day,
          title: this.prizeSettingList.title,
          price: this.prizeSettingList.price,
          assetsId: this.prizeSettingList.assetsId,
          singleAmount: this.prizeSettingList.singleAmount,
          prizeType: this.prizeSettingList.prizeType,
          logo: this.prizeSettingList.logo,
          freeTryOutPointNum: this.trialProducts.score,
          percentage: this.trialProducts.probability || 0,
          giftType: this.prizeSettingList.prizeType,
        },
      };
      if (this.nameTitle == "试用商品") {
        //试用商品
        this.element++;
        this.eleNumber++;
        this.element = parm;
        if (this.trialList.length >= 10) {
          this.$message.warning("最多支持添加10个试用商品");
          this.dialogFormVisible = true;
          return;
        } else {
          this.trialList.push(this.element);
        }
      } else {
        //编辑更新
        this.trialList[this.indexNum].title = this.prizeSettingList.title;
        this.trialList[this.indexNum].prize = this.prizeSettingList.logo;
        this.trialList[this.indexNum].price = this.prizeSettingList.price;
        this.trialList[this.indexNum].freeTryOutItemInfoDTOList = {
          assetsId: this.prizeSettingList.assetsId,
          freeEndTime: this.trialProducts.endTime,
          freeJoinType: cite,
          freeTryOutType: this.trialProducts.trialMode,
          freeLotteryOpenType: this.trialProducts.openMethods,
          totalAmount: this.trialProducts.prizes,
          freeWriteAddressType: this.trialProducts.shipToAddress,
          freeWriteAddressDay: this.trialProducts.day,
          title: this.prizeSettingList.title,
          price: this.prizeSettingList.price,
          assetsId: this.prizeSettingList.assetsId,
          singleAmount: this.prizeSettingList.singleAmount,
          prizeType: this.prizeSettingList.prizeType,
          logo: this.prizeSettingList.logo,
          freeTryOutPointNum: this.trialProducts.score,
          percentage: this.trialProducts.probability,
          giftType: this.prizeSettingList.prizeType,
        };
      }
      this.dialogFormVisible = false;
    },
    //上移
    moveUP(item, index) {
      if (this.trialList.length > 1 && index != 0) {
        var temp = this.trialList[index - 1];
        this.$set(this.trialList, index - 1, this.trialList[index]);
        this.$set(this.trialList, index, temp);
      }
    },
    //下移
    moveDown(item, index) {
      if (this.trialList.length > 1 && index != this.trialList.length - 1) {
        var temp = this.trialList[index + 1];
        this.$set(this.trialList, index + 1, this.trialList[index]);
        this.$set(this.trialList, index, temp);
      }
    },
    //删除
    deletePacket(params) {
      this.trialList.splice(params, 1);
    },
    //编辑
    edit(e, index) {
      if (e.freeTryOutItemInfoDTOList.freeJoinType == 3) {
        this.ruleForm.information = ["限会员", "限粉丝"];
        this.disItem = 1;
      }
      if (e.freeTryOutItemInfoDTOList.freeJoinType == 0) {
        this.ruleForm.information = ["-1"];
        this.disItem = 2;
      }
      if (e.freeTryOutItemInfoDTOList.freeJoinType == 1) {
        this.ruleForm.information = ["限会员"];
        this.disItem = 1;
      }
      if (e.freeTryOutItemInfoDTOList.freeJoinType == 2) {
        this.ruleForm.information = ["限粉丝"];
        this.disItem = 1;
      }
      this.indexNum = index;
      this.nameTitle = "编辑试用商品";
      console.log(e, 111);
      this.prizeSettingList = e.prizeSettingList;
      if (this.prizeSettingList.prizeType == 10) {
        this.isBelong = true;
      } else {
        this.isBelong = false;
      }
      (this.trialProducts = {
        trialMode: e.freeTryOutItemInfoDTOList.freeTryOutType, //试用方式
        openMethods: e.freeTryOutItemInfoDTOList.freeLotteryOpenType, //开奖方式
        shipToAddress: e.freeTryOutItemInfoDTOList.freeWriteAddressType, //收货地址填写
        score: e.freeTryOutItemInfoDTOList.freeTryOutPointNum, //消耗积分   没这个属性
        day: e.freeTryOutItemInfoDTOList.freeWriteAddressDay, //中奖后天数   没这个属性
        prizes: e.freeTryOutItemInfoDTOList.totalAmount, //奖品份数
        endTime: e.freeTryOutItemInfoDTOList.freeEndTime, //开奖时间
        probability: e.freeTryOutItemInfoDTOList.percentage, //中奖概率
        minNum: e.prizeSettingList.minNum, //奖品份数
      }),
        (this.dialogFormVisible = true);
    },
    //参与要求
    handleCheckedCitiesChange(val) {
      // let joinNum=val.join(',')
      // if(joinNum.includes('不限制')){
      //   this.trialProducts.checkedCities = ["不限制"]
      // }else{
      //   this.trialProducts.checkedCities = val;
      // }
    },
    typeDetail() {
      if (this.activeValue == 5) {
        //邀请开卡
        searchInvite({ id: this.valueRow.id }).then((res) => {
          this.ruleForm.isCumulativePrize = res.data.ruleDto.isCumulativePrize;
          if (res.data.ruleDto.isCumulativePrize) {
            this.tableData = res.data.ruleDto.cumulativePrizes.map(
              (item, index) => {
                let obj = {
                  peopleCount: item.cumulativeNum,
                  title: item.cumulativePrizeDTO.title,
                  assetsId: item.cumulativePrizeDTO.assetsId,
                  prizeType: item.cumulativePrizeDTO.prizeType,
                  logo: item.cumulativePrizeDTO.logo,
                  price:
                    item.cumulativePrizeDTO.price ||
                    item.cumulativePrizeDTO.singleAmount,
                  singleAmount: item.cumulativePrizeDTO.singleAmount,
                  prizeCount: item.cumulativePrizeDTO.totalAmount,
                };
                return obj;
              }
            );
          } else {
            let prize = res.data.ruleDto.cumulativePrizes;
            console.log(prize[0]);
            this.ruleForm.prizeCount = prize[0].cumulativePrizeDTO.totalAmount;
            this.prizeSettingList = {
              singleAmount: prize[0].cumulativePrizeDTO.singleAmount,
              title: prize[0].cumulativePrizeDTO.title,
              assetsId: prize[0].cumulativePrizeDTO.assetsId,
              prizeType: prize[0].cumulativePrizeDTO.prizeType,
              logo: prize[0].cumulativePrizeDTO.logo,
              price: prize[0].cumulativePrizeDTO.price,
              discount: prize[0].cumulativePrizeDTO.singleAmount,
            };
            this.setPrizeTxt(this.prizeSettingList);
            this.ruleForm.peopleCount = res.data.ruleDto.maxInviteNum || "";
          }
          this.activityTimeValue = [
            String(res.data.startTime),
            String(res.data.endTime),
          ];
          this.ruleForm.activityName = res.data.activityName;
          this.ruleForm.activityStartTime = String(res.data.startTime);
          this.ruleForm.activityEndTime = String(res.data.endTime);
          this.ruleForm.activityRulesText = String(res.data.ruleDescription); //生成规则
          this.ruleForm.partner = res.data.allowLevel.split(",");
          this.ruleForm.membershipTime = res.data.membershipTime
          this.ruleForm.exposureSwitch =
            res.data.isExposureItem == 0 ? false : true;
          // 商品处理
          let shopList = res.data.itemList
            ? res.data.itemList.map((item) => {
                return {
                  ...item,
                  numIid: item.wareId,
                  itemTitle: item.title,
                  picUrl: item.logo,
                };
              })
            : [];
          this.selectGoodsArr = shopList;
          this.itemListFor = shopList;
          this.mainImagelist = shopList;
          this.ruleForm.radio = res.data.priceType;
          this.activityTimeChange();
        });
      }
    },
    limitInput(event) {
      if (event.target.value == "0") {
        event.target.value = "";
      } else {
        event.target.value = event.target.value.replace(/[^\d]/g, "");
      }
    },
    itemDel(index) {
      if (this.tableData.length == 1) {
        this.$message.warning("梯度奖品必须有一个奖项");
        return;
      }
      this.tableData.splice(index, 1);
      console.log(this.tableData);
      // delete this
    },
    addPrizeRule() {
      this.tableData.push({
        peopleCount: "",
        prizeType: "",
        value: "",
        prizeCount: "",
      });
    },
    colseDialog() {
      // this.showDialog = false;
      // this.clickActual = true;
      console.log("clickActual", this.clickActual);
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          console.log(res, 6667);
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
          console.log(this.levelList, 111112);
        })
        .catch((res) => {});
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 117, // 设置宽度，单位像素
        height: 117, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    checkputn(e) {
      let filtered = e.target.value.replace(/^0|[^\d]/g, "");
      e.target.value = Number(filtered);
      console.log(filtered, e.target.value, this.ruleForm.peopleCount);
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value < 1) {
        e.target.value = "";
      }
    },
    //清空商品数据
    deleteCoupon() {
      this.prizeSettingList.price = null;
      this.prizeSettingList.title = "";
      this.prizeSettingList.assetsId = null;
      this.prizeSettingList.prizeType = null;
    },
    //选择商品数据
    getTheData(data, prizeType) {
      console.log(data, prizeType, "data");
      this.colseDialog();
      this.showDialog = false;
      this.prizeSettingList.singleAmount = 1;
      this.prizeSettingList.assetsId = Number(data.couponId);
      this.prizeSettingList.prizeType = prizeType;
      this.prizeSettingList.logo = data.logo;
      this.prizeSettingList.title = data.name || prizeType;
      this.prizeSettingList.price = data.discount;
      if (prizeType == 4) {
        this.prizeSettingList.title = prizeType;
        this.prizeSettingList.price = data.discount;
        this.prizeSettingList.singleAmount = data.singleAmount;
      } else if (prizeType == 2) {
        this.prizeSettingList.singleAmount = data.singleAmount;
        this.prizeSettingList.couponType = data.couponType;
        this.prizeSettingList.title = prizeType;
        this.prizeSettingList.quantityTotal = data.quantityTotal;
      } else if (prizeType == 10) {
        this.prizeSettingList.price = data.price;
        this.prizeSettingList.title = data.itemTitle;
        this.prizeSettingList.assetsId = data.id;
        this.prizeSettingList.logo = data.picUrl;
        this.isBelong = true;
      } else {
        this.isBelong = false;
      }
      console.log(this.prizeSettingList, "555555555");
    },
    setPrizeTxt(item) {
      if (item.prizeType == 8) {
        item.prizeTxt = item.price + "元";
      } else if (
        item.prizeType == 7 ||
        item.prizeType == 6 ||
        item.prizeType == 5
      ) {
        item.prizeTxt = item.price;
      } else {
        item.prizeTxt = item.singleAmount;
      }
    },
    //模板下一步
    nextStep() {
      this.localStepNum = this.activityData.id;
      this.localStep = 1;
      this.$emit("titopName", this.activityData.name, true);
    },
    //弹框确认
    // handleDialogCloseAnoth() {
    //   this.ruleForm.activityStartTime = this.activityTimeValue[0];
    //   this.ruleForm.activityEndTime = this.activityTimeValue[1];
    //   //日历签到
    //   let everyDay = {
    //     activityName: this.ruleForm.activityName, //活动名称
    //     allowLevel: this.ruleForm.partner.join(","), //参与会员等级：-1(全部)，0(非会员)，其余填会员等级
    //     condFollow: this.ruleForm.isFollow == true ? 1 : 0, //参与条件
    //     endTime: this.ruleForm.activityEndTime, //活动结束时间
    //     isExposureItem: this.ruleForm.exposureSwitch == false ? 0 : 1, //是否曝光商品：0否,1是
    //     itemList: this.itemListFor.map((item) => {
    //       return {
    //         logo: item.logo,
    //         price: item.price,
    //         title: item.title,
    //         skuId: item.skuId,
    //         wareId: item.numIid,
    //       };
    //     }), //曝光商品集合
    //     points: Number(this.ruleForm.inputprize), //单次奖励积分
    //     priceType: this.ruleForm.radio, //曝光商品价格显示：0显示淘宝价，1显示促销价
    //     pointActivityPrizeDTO: {
    //       //选择奖品数据
    //       price: this.prizeSettingList.price,
    //       title: this.prizeSettingList.title,
    //       assetsId: this.prizeSettingList.assetsId,
    //       prizeType: this.prizeSettingList.prizeType,
    //       logo: this.prizeSettingList.logo,
    //       couponType: this.prizeSettingList.couponType,
    //     },
    //     ruleDTO: {
    //       //规则拓展信息
    //       continueRule: this.itemArr,
    //       requestFollow: this.ruleForm.isFollow, //是否关注
    //       startTime: this.ruleForm.startTime,
    //       prizeCount: Number(this.ruleForm.prizeCount),
    //     },
    //     ruleDescription: this.ruleForm.activityRulesText, //规则拓展信息
    //     startTime: this.ruleForm.activityStartTime, //活动开始时间
    //   };
    //   //编辑回显
    //   this.momentValue = everyDay;
    //   //对象排序(根据对象的某一属性)
    //   if (this.draggingId.length != []) {
    //     let a = this.draggingId;
    //     let b = [];
    //     for (let i = 0; i < a.length; i++) {
    //       this.itemListFor.find((obj) => {
    //         // if (obj.wareId == a[i]) {
    //         //   b.push({
    //         //     logo: obj.logo,
    //         //     price: obj.price,
    //         //     title: obj.title,
    //         //     wareId: obj.wareId,
    //         //   });
    //         // }
    //         if (obj.skuId == a[i]) {
    //           b.push({
    //             logo: obj.logo,
    //             price: obj.price,
    //             title: obj.title,
    //             skuId: obj.skuId,
    //             wareId: obj.numIid,
    //           });
    //         }
    //       });
    //     }
    //     everyDay.itemList = b;
    //   }
    //   //活动名称的限制
    //   if (!this.ruleForm.activityName || this.ruleForm.activityName.length == 0) {
    //     this.$message.warning("请输入活动名称");
    //     return;
    //   }
    //   //活动时间的限制
    //   if (!this.ruleForm.activityStartTime || !this.ruleForm.activityEndTime) {
    //     this.$message.warning("请输入活动时间");
    //     return;
    //   }
    //   if (!this.ruleForm.activityRulesText) {
    //     this.$message.warning("活动规则不能为空");
    //     return;
    //   }
    //   //判断勾选提示后即可调取接口
    //   if (this.checked == true) {
    //     //通过活动来调取不一样的接口
    //     if (this.activityData.name == "邀请开卡有礼") {
    //       everyDay.ruleDTO = {};
    //       // 接口需要，points固定传个正数
    //       everyDay.points = 1;

    //       everyDay.ruleDTO.maxInviteNum = this.ruleForm.peopleCount;
    //       everyDay.ruleDTO.isCumulativePrize = this.ruleForm.isCumulativePrize;
    //       delete everyDay.pointActivityPrizeDTO;
    //       // 梯度奖励
    //       if (this.ruleForm.isCumulativePrize) {
    //         everyDay.ruleDTO.cumulativePrizes = this.tableData.map((item) => {
    //           let prize = {
    //             title: item.title,
    //             assetsId: item.assetsId,
    //             prizeType: item.prizeType,
    //             singleAmount: item.singleAmount,
    //             totalAmount: item.prizeCount,
    //           };
    //           if (prize.prizeType == 3) {
    //             prize.logo = item.logo;
    //           }
    //           if (prize.prizeType != 2 && prize.prizeType != 4) {
    //             console.log(item.price);
    //             prize.price = item.price;
    //           }
    //           return {
    //             cumulativeNum: item.peopleCount,
    //             cumulativePrizeDTO: prize,
    //           };
    //         });
    //         everyDay.ruleDTO.maxInviteNum = this.tableData[this.tableData.length - 1].peopleCount;
    //         console.log(everyDay.ruleDTO.cumulativePrizes);
    //       } else {
    //         let prize = {
    //           title: this.prizeSettingList.title,
    //           assetsId: this.prizeSettingList.assetsId,
    //           prizeType: this.prizeSettingList.prizeType,
    //           logo: this.prizeSettingList.logo,
    //           singleAmount: this.prizeSettingList.singleAmount,
    //           totalAmount: this.ruleForm.prizeCount,
    //         };
    //         if (prize.prizeType == 3) {
    //           prize.logo = this.prizeSettingList.logo;
    //         }
    //         if (prize.prizeType != 2 && prize.prizeType != 4) {
    //           prize.price = this.prizeSettingList.price;
    //         }

    //         everyDay.ruleDTO.cumulativePrizes = [
    //           {
    //             cumulativeNum: 1,
    //             cumulativePrizeDTO: prize,
    //           },
    //         ];

    //         console.log(this.prizeSettingList, 123);
    //       }

    //       // 编辑
    //       if (this.activeValue == 5) {
    //         everyDay.pointActivityId = this.valueRow.id;
    //         editInvite(everyDay)
    //           .then((res) => {
    //             if (res.code == 1) {
    //               this.$emit("saveEdit");
    //               this.$router.push({ path: "activeList" });
    //               this.$message.success(res.message);
    //             } else {
    //               this.$message.error(res.message);
    //             }
    //           })
    //           .catch(() => {});
    //       } else {
    //         invite(everyDay)
    //           .then((res) => {
    //             if (res.code == 1) {
    //               this.$emit("saveEdit");
    //               this.$router.push({ path: "activeList" });
    //               this.$message.success(res.message);
    //             } else {
    //               this.$message.error(res.message);
    //             }
    //           })
    //           .catch(() => {});
    //       }
    //     }
    //     this.joinBlackList = false;
    //     return;
    //   } else {
    //     this.$message.info("请勾选明确活动规则后即可创建");
    //     return;
    //   }
    // },
    // 检查奖品总数
    async checkedPrizeCount(item) {
      await this.setPromise(item);
    },
    setPromise(item) {
      if (item.priceType == 2) {
        return new Promise((resolve, reject) => {
          const formLitJD = {
            current: 1,
            size: 100,
            isFilterUsed: true,
            status: 2,
          };
          jingdouList(formLitJD)
            .then((res) => {
              res.filter((i) => {
                // 对应的计划
                if (i.id == item.assetsId) {
                  // 奖品总份数为空
                  if (!item.totalAmount) {
                  }
                }
              });
              resolve(res);
            })
            .catch((res) => {});
        });
      }
    },
    // getJingdouList() {
    //   jingdouList(this.formLitJD)
    //     .then((res) => {
    //       let selectArr = res.data.records.map((item) => {
    //         return {
    //           label: item.planName,
    //           value: item.id,
    //         };
    //       });
    //       this.selectList = selectArr;
    //       this.planList.jingdou = res.data.records
    //     })
    //     .catch((res) => {});
    // },
    //时间
    clearTime(a, b) {
      this.ruleForm.activityStartTime = null;
      this.ruleForm.activityEndTime = null;
    },
    //删除
    delec(item, index) {
      let i = -1;
      this.mainImagelist.forEach((items, index1) => {
        if (items.skuId == item.skuId) i = index1;
      });
      if (i != -1) {
        this.mainImagelist.splice(i, 1);
        this.itemListFor = this.mainImagelist;
        // this.itemListFor.splice(i, 1);
      }
      console.log(this.mainImagelist, 4444444);
    },
    //完善信息删除
    deleteaInfo(index) {
      this.itemArrOne.splice(index, 1);
    },
    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelist.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        this.draggingId = arr;
      });
    },
    //商品回调
    selectGoodsChange(val) {
      this.goodsState = false;
    },
    //连续签到送积分
    signInpoints(val) {
      this.ruleForm.singScore = val;
    },
    //连续签到删除
    deletea(index) {
      this.itemArr.splice(index, 1);
    },
    // 活动进行中修改奖品数量
    beAdd() {
      console.log("活动进行中修改奖品数量", this.trialProducts);
      if (this.isStartEdit) {
        if (
          this.trialProducts.minNum &&
          Number(this.trialProducts.prizes) < Number(this.trialProducts.minNum)
        ) {
          this.trialProducts.prizes = this.trialProducts.minNum;
          this.$message.warning("为避免客诉，奖品数量不能小于之前哦~");
        }
      }
    },
    //添加条件
    addCondition() {
      let parm = {
        continueSignPoints: this.itemArr.continueSignPoints,
        days: this.itemArr.days,
      };
      this.ele++;
      this.ele = parm;
      this.itemArr.push(this.ele);
    },
    //完善信息的添加
    perfectAdd() {
      let valueParm = {
        informationmation: this.itemArrOne.informationmation,
        informationmationOne: this.itemArrOne.informationmationOne,
      };
      this.element++;
      this.element = valueParm;
      this.itemArrOne.push(this.element);
    },
    //奖品设置
    prizeSetChange(val) {
      if (val == true) {
        this.limit = false;
      } else {
        this.limit = true;
        this.ruleForm.inputprize = "";
      }
    },
    //活动时间驱动
    activityTimeChange(val) {
      if (this.isStartEdit) {
        //进行中活动 无法修改活动开启时间
        this.activityTimeValue[0] = this.isStartEditTime;
      }
      this.ruleForm.activityStartTime = this.activityTimeValue[0];
      this.ruleForm.activityEndTime = this.activityTimeValue[1];
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.activityStartTime).valueOf();
      let end = new Date(this.ruleForm.activityEndTime).valueOf();
      let invalidateDate = new Date(
        this.$store.state.loginUserInfo.expiredIn
      ).valueOf();
      if (this.backgroundOpacity) {
        var datas, change1, change2, days, daysStart, daysEnd, date3;
        daysStart = this.ruleForm.activityStartTime.substring(0, 10);
        daysEnd = this.ruleForm.activityEndTime.substring(0, 10);
        if (
          this.ruleForm.activityEndTime != "" &&
          this.ruleForm.activityStartTime != ""
        ) {
          datas = daysEnd.split("-");
          change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
          datas = daysStart.split("-");
          change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
          days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
          this.timeDay = days;
          //计算小时
          date3 =
            new Date(this.ruleForm.activityEndTime).getTime() -
            new Date(this.ruleForm.activityStartTime).getTime();
          var leave1 = date3 % (24 * 3600 * 1000);
          this.timeOut = Math.floor(leave1 / (3600 * 1000));
        } else {
          this.timeOut = 0;
          return;
        }
        return;
      }
      if (end > invalidateDate) {
        this.$message.warning("活动时间不能超过软件有效期，请重新选择");
        this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = null;
        return;
      }
      if (start < nowTime) {
        if (this.activeValue) {
          this.disableTime = true;
        } else {
          if (!this.isStartEdit) {
            this.$message.warning("开始时间不能小于当前时间");
          }
          // this.ruleForm.activityStartTime = null;
          // return;
        }
      }
      if (end < nowTime) {
        this.$message.warning("结束时间不能小于当前时间");
        // this.ruleForm.activityEndTime = null;
        // return;
      }
      if (end < start) {
        this.$message.warning("结束时间不能小于开始时间");
        // this.activityTimeValue[1] = "";
        // this.ruleForm.activityEndTime = null;
        return;
      }
      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart = this.ruleForm.activityStartTime.substring(0, 10);
      daysEnd = this.ruleForm.activityEndTime.substring(0, 10);
      if (
        this.ruleForm.activityEndTime != "" &&
        this.ruleForm.activityStartTime != ""
      ) {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        this.timeDay = days;
        //计算小时
        date3 =
          new Date(this.ruleForm.activityEndTime).getTime() -
          new Date(this.ruleForm.activityStartTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
        return;
      }
      if (
        this.ruleForm.activityEndTime &&
        this.ruleForm.activityStartTime &&
        this.ruleForm.activityEndTime.substring(0, 10) ==
          this.ruleForm.activityStartTime.substring(0, 10)
      ) {
        this.$message.warning("活动时间不能小于一天");
        this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = "";
      }
    },
    // 返回上一步
    returnBack() {
      this.$emit("returnBack");
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    //保存编辑
    saveEdit() {
      // console.log(this.ruleForm.isCumulativePrize);
      let state = true;
      if (this.ruleForm.isCumulativePrize) {
        let arr = this.tableData.map((i) => {
          return i.peopleCount;
        });
        if (arr.indexOf("") != -1) {
          return this.$message.error("邀请人数不可为空");
        }
        var flagSort = false;
        for (let i = 0; i < arr.length; i++) {
          if (arr[i + 1]) {
            if (Number(arr[i]) >= Number(arr[i + 1])) {
              flagSort = true;
              break;
            }
          }
        }
        if (flagSort) {
          return this.$message.error("邀请人数梯度不可小于或等于上一个梯度");
        }

        for (let index = 0; index < arr.length; index++) {
          const element = arr[index];
          if (this.tableData[index].prizeType == "") {
            return this.$message.error("请在条件中设置奖品");
          }
          for (
            let indexSecond = index;
            indexSecond < arr.length;
            indexSecond++
          ) {
            console.log(element, arr[indexSecond], element > arr[indexSecond]);
            if (Number(element) > Number(arr[indexSecond])) {
              state = false;
            }
          }
        }
        if (!state) {
          return this.$message.error("邀请人数梯度不可小于上一个梯度");
        }
      }
      console.log(
        "this.ruleForm.activityEndTime && this.trialProducts.endTime",
        this.ruleForm.activityEndTime && this.trialProducts.endTime,
        111,
        this.ruleForm.activityEndTime,
        222,
        this.trialProducts.endTime
      );
      if (this.ruleForm.activityEndTime && this.trialProducts.endTime) {
        let time1 = new Date(this.ruleForm.activityEndTime).getTime();
        let time2 = new Date(this.trialProducts.endTime).getTime();
        let timeDiff = Math.abs(time2 - time1);
        let hoursDiff = timeDiff / (1000 * 60 * 60);
        if (hoursDiff < 48 || time1 - time2 < 0) {
          // console.log('两个时间相差48小时以内');
          this.$message.warning("开奖时间要在活动结束时间之前至少48小时！");
          return;
        } else {
          // console.log('两个时间相差超过48小时');
        }
      }

      // console.log(this.ruleForm.informationOne);
      // console.log(this.itemArrOne);
      this.joinBlackList = true;
      // this.$emit("saveEdit");
    },
    // 下一步
    resetForm() {
      this.joinBlackList = true;
    },
    //添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      // console.log(this.itemListFor);
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      // debugger
      // this.$refs.selectGo.handleRightCurrentChange(1);
      // console.log(this.selectGoodsArr);
      // return
    },
    selectGoodsSure(data) {
      if (!data) {
        this.selectGoodsState = false;
        return;
      }
    },
    selectGoodsClose(event, index) {
      // console.log(data);
      // // debugger
      // if (data) {
      //   console.log(data);
      //   this.itemListFor = [];
      //   this.mainImagelist = [];
      //   data.forEach((value, index) => {
      //     let fomeVaule = {};
      //     fomeVaule.skuId = data[index].skuId;
      //     fomeVaule.logo = data[index].logo;
      //     fomeVaule.price = data[index].jdPrice || data[index].price;
      //     fomeVaule.title = data[index].wareTitle || data[index].title;
      //     this.itemListFor.push(fomeVaule);
      //     this.mainImagelist.push(fomeVaule);
      //   });
      //   this.selectGoodsArr = this.itemListFor;
      // }
      if (typeof event != "boolean") {
        let newArr = event;
        // event.forEach((item) => {
        //   newArr.push(item.numIid);
        // });
        if (index && index == 1) {
          this.itemListFor = newArr;
          this.mainImagelist = newArr;
          this.selectGoodsArr = newArr;
        }
      }
      // console.log(this.selectGoodsArr, this.itemListFor, 3333);
      this.selectGoodsState = false;
    },
    //选中改变
    checkListchange(val) {
      console.log(val);
      console.log(this.levelList);
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
        }
      });
    },
    // 返回上一步
    clickLocalStep() {
      sessionStorage.setItem("goBack", this.activityData.goIndex);
      if (this.$route.query.copyParams && this.$route.query.copyParams.isCopy) {
        sessionStorage.setItem("goBackCopy", true);
      }
      this.$router.go(-1);
      // if (this.backgroundOpacity) {
      //   this.$emit("returnBack");
      //   return;
      // }
      // this.localStep = 0;
      // this.localStepNum = 0;
      // this.$emit("titopName", this.activityData.name, false);
    },
    checkputnCount(e, row) {
      if (row.quantityTotal && row.price && row.prizeCount) {
        let numTotal = this.$jingdouTotal(row);
        if (!numTotal) {
          this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
        }
        return numTotal;
      } else {
        return row.prizeCount;
      }
    },
    // 品牌定制弹窗
    handleOpen() {
      const href =
        "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    handleActivityObj() {
      this.ruleForm.newOldCustomer = 0;
      this.ruleForm.partner = ["-1"];
      this.peopleList = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.date_icon3 {
  width: 60px;
  height: 60px;
  vertical-align: middle;
}
.theLag {
  position: relative;
  margin-top: 10px;
  height: 142px;
  width: 302px;
  .theBox {
    height: 142px;
    width: 302px;
    // border: 1px solid #999;
    background: url("../../assets/thdImg/pages/yhq.svg") no-repeat;
    border-radius: 8px;
    position: absolute;
    color: #333333;
    .price_sty {
      font-family: DIN;
      font-weight: bold;
      color: #2670fb;
      font-size: 45px;
    }
    .pp {
      width: 280px;
      text-align: center;
      bottom: 0px;
    }
  }

  .btnQx {
    display: none;
  }
  &:hover {
    .btnQx {
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      margin: -16px 0 0 -49px;
    }
    .backgrd {
      width: 302px;
      height: 142px;
      background: #fff;
      position: absolute;
      border-radius: 8px;
      opacity: 0.7;
    }
  }
}
.wide {
  width: 750px;
  height: 416px;
  background: #f8f9ff;
  border-radius: 8px 8px 8px 8px;
  opacity: 1;
  margin-bottom: 10px;
  padding: 20px;
  position: relative;
  line-height: 21px;
  color: #666666;
  .posi {
    position: absolute;
    right: 24px;
    top: 22px;
  }
}
.imgUpload {
  display: flex;
  align-items: center;
}
/deep/.stepBox .el-step.is-horizontal .el-step__line {
  left: 155px;
}
/deep/.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/deep/.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
/deep/.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 130px;
  height: 230px;
  line-height: 230px;
  text-align: center;
}
/deep/.avatar {
  width: 130px;
  height: 230px;
  display: block;
}
/deep/ .el-table__row:hover {
  .delQx {
    display: flex;
  }
}
.startTime {
  /deep/ .el-table__body-wrapper {
    padding-left: 30px !important;
  }
}
.prosi {
  position: absolute;
  bottom: 45px;
  right: 20px;
}
.delectPosible:hover {
  -webkit-box-shadow: #ccc 0px 1px 1px;
  -moz-box-shadow: #ccc 0px 1px 1px;
  box-shadow: #ccc 0px 1px 1px;
}
.flex {
  display: flex;
  align-items: center;
}
.del_box {
  position: absolute;
  left: 145px;
  top: 15px;
  width: 50px;
  height: 50px;
}
.delQx {
  width: 25px;
  height: 25px;
  background: rgb(255, 76, 68);
  display: inline-block;
  display: none;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img {
    width: 50px;
    margin-right: 4px;
  }
  // display: none;
}
.prize_box {
  padding: 26px 21px;
  background: #fcfcfc;
  .tips {
    width: 600px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    background: #fffaee;
    border-radius: 3px;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    margin-bottom: 9px;
  }
  .add_btn {
    cursor: pointer;
    color: #7f85e9;
    border: 1px dashed #7f85e9;
    width: 625px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 8px;
  }
}
.line {
  display: flex;
  align-items: center;
}
.createPlayStep {
  min-width: 1360px;
  position: relative;
  box-sizing: border-box;
  min-height: 80vh;
  height: 88.5vh;
  background-color: #fff;
  border-radius: 6px;
  margin: 24px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      margin-left: 11%;
    }
  }
  .firststep {
    min-height: 820px;
    box-sizing: border-box;
    padding: 35px 35px 0;
    .itemList {
      display: flex;
      .item {
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #fe4d45;
            border-bottom: 1px solid #fe4d45;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #fe4d45;
            border-left: 1px solid #fe4d45;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          .queryId {
            display: none;
          }
          &:hover {
            .queryId {
              display: block;
            }
            .mask {
              opacity: 1;
            }
          }
          .mask {
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 10px;
                color: #fff;
                // opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
      background: rgba(38, 112, 251, 0.1);
      border: 1px solid #2670fb;
      color: #2670fb;
      border-radius: 4px;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .theLag {
      position: relative;
      margin-top: 10px;
      height: 142px;
      width: 302px;
      .theBox {
        height: 142px;
        width: 302px;
        background: url("../../assets/thdImg/pages/yhq.svg") no-repeat;
        border-radius: 8px;
        position: absolute;
        color: #333333;
        .price_sty {
          font-family: DIN;
          font-weight: bold;
          color: #2670fb;
          font-size: 45px;
        }
        .pp {
          width: 280px;
          text-align: center;
          bottom: 0px;
        }
      }

      .btnQx {
        display: none;
      }
      &:hover {
        .btnQx {
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          margin: -16px 0 0 -49px;
        }
        .backgrd {
          width: 302px;
          height: 142px;
          background: #fff;
          position: absolute;
          border-radius: 8px;
          opacity: 0.7;
        }
      }
    }

    .productImg {
      margin-top: 10px;
      background-color: #fafafa;
      min-height: 80px;
      width: 800px;
      border-radius: 5px;
    }
    .desc {
      i {
        opacity: 0.7;
        color: #fe4d45;
      }
      color: #999;
    }
    .returnBtn {
      width: 148px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(254, 77, 69, 1);
      color: #fe4d45;
      transition: all 0.2s;
      &:hover {
        background-color: #fe4d45;
        color: #fff;
      }
    }
    .keepBtn {
      margin-left: 30px;
      width: 188px;
      background-color: #fe4d45;
      color: #fff;
      transition: all 0.2s;
      &:hover {
        opacity: 0.9;
      }
    }
  }
}
.wrapper-kaika {
  width: 100%;
  height: 100%;
  display: grid;
  &-img {
    background-color: #fafafa;
    border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
    border-radius: 8px;
    height: 350px;
    position: relative;
    &:hover {
      .borderkaika::before,
      .borderkaika::after {
        opacity: 1;
        transform: scale(1);
      }
    }
    .borderkaika {
      position: absolute;
      left: -6px;
      top: -6px;
      width: 218px;
      height: 360px;
      border-radius: 4px;
      &::before,
      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        content: "";
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.8s, transform 0.8s;
        border-radius: 4px;
      }
      &::before {
        border-top: 1px solid #fe4d45;
        border-bottom: 1px solid #fe4d45;
        -webkit-transform: scale(0, 1);
        transform: scale(0, 1);
      }
      &::after {
        border-right: 1px solid #fe4d45;
        border-left: 1px solid #fe4d45;
        -webkit-transform: scale(1, 0);
        transform: scale(1, 0);
      }
    }

    div {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
    }
    img {
      width: 32px;
      height: 32px;
    }

    .queryIdIMG {
      display: none;
    }
    &:hover {
      .queryIdIMG {
        display: block;
      }
      .mask {
        opacity: 1;
      }
    }
    .mask {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.6);
      color: #fff;
      opacity: 0;
      transition: all 0.2s;
      .img {
        max-width: 130px;
        margin: 0 auto 30px;
        .imgBg {
          box-sizing: border-box;
          height: 129px;
          width: 129px;
          padding: 6px;
          border-radius: 6px;
          background-color: #fff;
        }
        .tpl {
          display: inline-block;
          font-size: 14px;
          color: #fff;
          margin-top: 10px;
        }
      }
    }
  }
  &-tanchuang {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .lijijq {
    &::after {
      content: "立即领取";
      display: block;
      position: absolute;
      bottom: 9px;
      left: 51%;
      transform: translateX(-50%);
      font-size: 14px;
      font-family: system-ui;
      font-weight: bold;
      color: #ed6e09;
      text-shadow: 0 0 black;
    }
  }
}
.rulebox {
  width: 750px;
  min-height: 300px;
  background: #f8f9ff;
  border-radius: 8px;
  margin-top: 10px;
  padding: 24px;
  line-height: 30px;
  &_flex {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    &_left {
      width: 100px;
    }
    &_btn {
      padding: 0px 10px;
      height: 32px;
      color: #2670fb;
      line-height: 32px;
      background: rgba(38, 112, 251, 0.1);
      border-radius: 4px;
      border: 1px solid #2670fb;
    }
  }
  .createAdd_save {
    margin-top: 24px;
    width: 100px;
    height: 32px;
    background: #2670fb;
    margin-right: 20px;
    border-radius: 4px;
    color: #fff;
    line-height: 32px;
    text-align: center;
    &:hover {
      opacity: 0.8;
    }
  }
  .createAdd_qx {
    margin-top: 24px;
    width: 100px;
    height: 32px;
    background: #fff;
    margin-right: 20px;
    border-radius: 4px;
    color: #606266;
    line-height: 32px;
    text-align: center;
    border: 1px solid #dddddd;
    &:hover {
      color: #fff;
      background: #2670fb;
      border: 1px solid #2670fb;
    }
  }
}
</style>
